__turbopack_context__.v({
  "className": "_2V2uLG_className",
  "variable": "_2V2uLG_variable",
});
